import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../Images/circle-info-regular-full.svg'

function Name ({ localFullName, setLocalFullName }) {
  const handleFirstNameChange = event => {
    setLocalFullName(prev => ({ ...prev, name: event.target.value }))
  }

  const handleLastNameChange = event => {
    setLocalFullName(prev => ({ ...prev, lastName: event.target.value }))
  }

  return (
    <section className={styles.nameComponentSection}>
      <h1 className={styles.nameComponentTitle}>Name</h1>
      <div className={styles.nameComponentInputContainer}>
        {/* First name */}
        <div className={styles.nameComponentInputWrapper}>
          <div className={styles.labelWithIcon}>
            <label className={styles.nameComponentLabel} htmlFor='firstName'>
              First name
            </label>
            <Tooltip
              title='The given name of the person.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='First name help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>
          <input
            autoComplete='off'
            className={styles.nameComponentInput}
            placeholder='Text'
            type='text'
            id='firstName'
            value={localFullName.name}
            onChange={handleFirstNameChange}
          />
        </div>

        {/* Last name */}
        <div className={styles.nameComponentInputWrapper}>
          <div className={styles.labelWithIcon}>
            <label className={styles.nameComponentLabel} htmlFor='lastName'>
              Last name
            </label>
            <Tooltip
              title='The family name or surname of the person.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Last name help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>
          <input
            className={styles.nameComponentInput}
            value={localFullName.lastName}
            placeholder='Text'
            type='text'
            id='lastName'
            onChange={handleLastNameChange}
          />
        </div>
      </div>
    </section>
  )
}

export default Name
